__turbopack_context__.v({
  "mobileButton": "y3TwYa_mobileButton",
});
